import axios from "../../../util/axios";

const PREFIX_URI = "/basedata/kpi/calendar";

export default {
    /** 查询有效职员（平台启用职员） */
    queryEmployeeStaff: (data) => axios.get({url: `${PREFIX_URI}/queryEmployeeStaff`, data}),
    /** 查询某员工某月 kpi日历（含 1工作日志/2kpi任务拆解/3开发节点） */
    queryMonth: (data) => axios.get({url: `${PREFIX_URI}/queryMonth`, data: data}),
    /** 查询某员工某日 kpi日历 */
    queryDay: (employeeId, date) => axios.get({url: `${PREFIX_URI}/queryDay`, data: {employeeId, date}}),
    /** 按 id 查询 kpi任务（编辑回显） */
    findTask: (id) => axios.get({url: `${PREFIX_URI}/findTask`, data: {id: id}}),
    /** 保存 KPI任务（按起止日期自动拆分出每日 kpi日历；传 shiftOtherTask=1 顺延冲突任务） */
    save: (data) => axios.post({url: `${PREFIX_URI}/save`, data: data}),
    /**
     * 完成/记录某日工作（POST body 为一行 kpi日历数据）：
     *  - calendarType=1 工作日志：直接更新该日志内容
     *  - calendarType=2/3 任务拆解/开发节点：更新该行状态后，把内容合并进当天唯一的工作日志
     *  - kpiStatus=50 表示延期（后端会把该任务后续行整体 +1 天）
     */
    markDone: (data) => axios.post({url: `${PREFIX_URI}/markDone`, data: data}),
    /**
     * 保存日程（calendarType 只能是 4拜访客户 / 5线上会议 / 6线下会议 / 7产品学习 / 8商机客户 / 99其它）
     * 与 save 的区别：save 建的是跨日 KPI任务、会按起止日期拆成多行；
     * 本接口只落一行，日期由日程自己指定。
     * type=4 必须带客户 partnerId，type=8 必须带商机 partnerId（都是 ba_business_partner.id）。
     */
    saveSchedule: (data) => axios.post({url: `${PREFIX_URI}/saveSchedule`, data}),
    /**
     * 修改日历任务（只改名称与备注）
     * 与 save 的区别：save 改的是 KPI 任务、会重新拆分全程；
     * 本接口只动 ba_kpi_calendar 这一行，不碰它所属的 kpi任务
     */
    saveCalendarRow: (data) => axios.post({url: `${PREFIX_URI}/saveCalendarRow`, data}),
    /** 删除一条 kpi日历数据 */
    delete: (id) => axios.get({url: `${PREFIX_URI}/delete`, data: {id: id}}),
    /** 日程统计（报表中心）：总数/本月/完成率 + 类型分布 + 月度趋势 + 明细 */
    scheduleStat: (data) => axios.get({url: `${PREFIX_URI}/scheduleStat`, data}),
};
